export var US_STATE_SHORTHAND_TO_NAME = function(strictLocalize) {
    return {
        AL: strictLocalize({
            id: "wmeDqJ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Alabama"
                }
            ]
        }),
        AK: strictLocalize({
            id: "5lxqUv",
            defaultMessage: [
                {
                    type: 0,
                    value: "Alaska"
                }
            ]
        }),
        AZ: strictLocalize({
            id: "vYeQLa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Arizona"
                }
            ]
        }),
        AR: strictLocalize({
            id: "qom+Ot",
            defaultMessage: [
                {
                    type: 0,
                    value: "Arkansas"
                }
            ]
        }),
        CA: strictLocalize({
            id: "wAkNat",
            defaultMessage: [
                {
                    type: 0,
                    value: "California"
                }
            ]
        }),
        CO: strictLocalize({
            id: "s5fKc2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Colorado"
                }
            ]
        }),
        CT: strictLocalize({
            id: "lZwbC5",
            defaultMessage: [
                {
                    type: 0,
                    value: "Connecticut"
                }
            ]
        }),
        DE: strictLocalize({
            id: "sq0cms",
            defaultMessage: [
                {
                    type: 0,
                    value: "Delaware"
                }
            ]
        }),
        DC: strictLocalize({
            id: "TH/zlq",
            defaultMessage: [
                {
                    type: 0,
                    value: "District of Columbia"
                }
            ]
        }),
        FL: strictLocalize({
            id: "mEm5JV",
            defaultMessage: [
                {
                    type: 0,
                    value: "Florida"
                }
            ]
        }),
        GA: strictLocalize({
            id: "b89qA1",
            defaultMessage: [
                {
                    type: 0,
                    value: "Georgia"
                }
            ]
        }),
        HI: strictLocalize({
            id: "1cIpYC",
            defaultMessage: [
                {
                    type: 0,
                    value: "Hawaii"
                }
            ]
        }),
        ID: strictLocalize({
            id: "b8MimM",
            defaultMessage: [
                {
                    type: 0,
                    value: "Idaho"
                }
            ]
        }),
        IL: strictLocalize({
            id: "7sTv2S",
            defaultMessage: [
                {
                    type: 0,
                    value: "Illinois"
                }
            ]
        }),
        IN: strictLocalize({
            id: "nTBWjF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Indiana"
                }
            ]
        }),
        IA: strictLocalize({
            id: "IAS4Wo",
            defaultMessage: [
                {
                    type: 0,
                    value: "Iowa"
                }
            ]
        }),
        KS: strictLocalize({
            id: "Hha11U",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kansas"
                }
            ]
        }),
        KY: strictLocalize({
            id: "WLIUVS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kentucky"
                }
            ]
        }),
        LA: strictLocalize({
            id: "nyb4LF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Louisiana"
                }
            ]
        }),
        ME: strictLocalize({
            id: "rz8hJP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Maine"
                }
            ]
        }),
        MD: strictLocalize({
            id: "xUYpat",
            defaultMessage: [
                {
                    type: 0,
                    value: "Maryland"
                }
            ]
        }),
        MA: strictLocalize({
            id: "8TFEDP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Massachusetts"
                }
            ]
        }),
        MI: strictLocalize({
            id: "/IHRgu",
            defaultMessage: [
                {
                    type: 0,
                    value: "Michigan"
                }
            ]
        }),
        MN: strictLocalize({
            id: "eUxvSR",
            defaultMessage: [
                {
                    type: 0,
                    value: "Minnesota"
                }
            ]
        }),
        MS: strictLocalize({
            id: "FFYArQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mississippi"
                }
            ]
        }),
        MO: strictLocalize({
            id: "8Lb7OO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Missouri"
                }
            ]
        }),
        MT: strictLocalize({
            id: "8jnTm5",
            defaultMessage: [
                {
                    type: 0,
                    value: "Montana"
                }
            ]
        }),
        NE: strictLocalize({
            id: "I46BF7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nebraska"
                }
            ]
        }),
        NV: strictLocalize({
            id: "VwqHI0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nevada"
                }
            ]
        }),
        NH: strictLocalize({
            id: "feuWa4",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Hampshire"
                }
            ]
        }),
        NJ: strictLocalize({
            id: "yr/A9F",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Jersey"
                }
            ]
        }),
        NM: strictLocalize({
            id: "pYffjQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Mexico"
                }
            ]
        }),
        NY: strictLocalize({
            id: "gkKsyP",
            defaultMessage: [
                {
                    type: 0,
                    value: "New York"
                }
            ]
        }),
        NC: strictLocalize({
            id: "H23UbB",
            defaultMessage: [
                {
                    type: 0,
                    value: "North Carolina"
                }
            ]
        }),
        ND: strictLocalize({
            id: "/mqtw0",
            defaultMessage: [
                {
                    type: 0,
                    value: "North Dakota"
                }
            ]
        }),
        OH: strictLocalize({
            id: "0TVMNa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ohio"
                }
            ]
        }),
        OK: strictLocalize({
            id: "Nhk6XQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Oklahoma"
                }
            ]
        }),
        OR: strictLocalize({
            id: "fSfobJ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Oregon"
                }
            ]
        }),
        PA: strictLocalize({
            id: "9d0QFI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Pennsylvania"
                }
            ]
        }),
        PR: strictLocalize({
            id: "f/ISAk",
            defaultMessage: [
                {
                    type: 0,
                    value: "Puerto Rico"
                }
            ]
        }),
        RI: strictLocalize({
            id: "clJ3lI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Rhode Island"
                }
            ]
        }),
        SC: strictLocalize({
            id: "1/s9as",
            defaultMessage: [
                {
                    type: 0,
                    value: "South Carolina"
                }
            ]
        }),
        SD: strictLocalize({
            id: "fGzPC0",
            defaultMessage: [
                {
                    type: 0,
                    value: "South Dakota"
                }
            ]
        }),
        TN: strictLocalize({
            id: "ErN6HW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tennessee"
                }
            ]
        }),
        TX: strictLocalize({
            id: "t95KOv",
            defaultMessage: [
                {
                    type: 0,
                    value: "Texas"
                }
            ]
        }),
        UT: strictLocalize({
            id: "PL2vOg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Utah"
                }
            ]
        }),
        VT: strictLocalize({
            id: "Q7PZxN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Vermont"
                }
            ]
        }),
        VA: strictLocalize({
            id: "FjfR/c",
            defaultMessage: [
                {
                    type: 0,
                    value: "Virginia"
                }
            ]
        }),
        WA: strictLocalize({
            id: "nHeH9O",
            defaultMessage: [
                {
                    type: 0,
                    value: "Washington"
                }
            ]
        }),
        WV: strictLocalize({
            id: "J/zbKY",
            defaultMessage: [
                {
                    type: 0,
                    value: "West Virginia"
                }
            ]
        }),
        WI: strictLocalize({
            id: "cmRgFg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Wisconsin"
                }
            ]
        }),
        WY: strictLocalize({
            id: "BInQ24",
            defaultMessage: [
                {
                    type: 0,
                    value: "Wyoming"
                }
            ]
        })
    };
};
